module.exports = __webpack_public_path__ + "static/media/lakeCity.e3d465ea.jpg";